


import React, { useContext, useEffect, useReducer, useState } from "react";
import {  useNavigate } from "react-router-dom";
import {  Button, Modal, Nav, Tab } from "react-bootstrap";
import 'react-datepicker/dist/react-datepicker.css';


import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { getAllUserApi } from "../../../service/user/getAllUsers";
import UserTable from "./userTable";
import { assignPropertyUserApi } from "../../../service/user/assignPropertyUser";
import { getUserByPropIdApi } from "../../../service/property/getUserByPropId";
import { setLoading } from "../../../feature/authSlice";

const AssignUserModal = ({handleModalView,modalView,getUserData}) => {
  const {PropertyId,customerId} = useSelector(state => state.auth)
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const[userListArr,setUserListArr] = useState([])
const[apiLoading,setApiLoading] = useState(false)
  const [pageViewUser, setPageViewUser] = useState(1);
  const [pageSizeViewUser, setPageSizeViewUser] = useState(5);
  const [totalPageViewUser, setTotalPageViewUser] = useState(1);
  const [searchValueViewUser, setSearchValueViewUser] = useState("");
  const [totalViewUserCount, setTotalViewUserCount] = useState(0);
  const [userModalView,setUserModalView] = useState(false)
  const [userData,setUserData] = useState({})
 const [modalType,setModalType] = useState(1)
 const [selectedRows,setSelectedRows] = useState([])
  const handleSearchViewUser = (e) => {
    // pageViewUser(1)

    setSearchValueViewUser(e.target.value);
    if (searchValueViewUser.trim().length >= 2) {
      onChangePageViewUser(1);
    }
  };

  const handleChangeRowsPerPageViewUser= (e) => {
    // console.log(e)
    setSearchValueViewUser("");
    setPageViewUser(1);
    setPageSizeViewUser(e.target.value);
  };

  const onChangePageViewUser = (e, p) => {
    // setPage(p);
    setPageViewUser(e);
  };
 
  const columns = [
    {
        Header: "  ",
        Footer: "  ",
        accessor: "hjhjj",
      },
    {
      Header: "First Name ",
      Footer: "First Name ",
      accessor: "FirstName",
    },
   
    {
      Header: "Last Name",
      Footer: "Last Name",
      accessor: "LastName",
    },
    {
      Header: "User Email",
      Footer: "User Email",
      accessor: "Email",
    },
    {
      Header: "User Phone",
      Footer: "User Phone",
      accessor: "PhoneNumber",
    },
   

  ];

  useEffect(()=>{
onLoadData()
  },[pageViewUser])

  function onLoadData (){
    setApiLoading(true)
    
    var data ={
      Filter: "",
      OrderBy: "",
      PageSize: pageSizeViewUser,
      PageNumber: pageViewUser,
      Keyword: searchValueViewUser,
      PropertyId:localStorage.getItem("propId")
    }
    dispatch(getAllUserApi(data,(response)=>{
        setApiLoading(false)
        
        setUserListArr(response.data.result.List)

        setTotalViewUserCount(response.data.result.TotalCount);
        if (parseInt(response?.data?.result?.TotalCount) % pageSizeViewUser === 0) {
          setTotalPageViewUser(parseInt(response?.data?.result?.TotalCount / pageSizeViewUser));
        } else {
            setTotalPageViewUser(
            parseInt(response?.data?.result?.TotalCount / pageSizeViewUser + 1)
          );
        }
    },(res)=>{
        setApiLoading(false)
        
    }))
  }

  function handleAddUserModal (type){
    setModalType(type)
    setUserModalView(!userModalView)
    if(userModalView){
      onLoadData()
    }
  }
  useEffect(() => {
    let typingTimer;

    // Clear the previous typing timer
    clearTimeout(typingTimer);

    // Set a new typing timer
    typingTimer = setTimeout(() => {
      onLoadData();
    
    }, 1500);

    // Clean up the timer when component unmounts or search values change
    return () => clearTimeout(typingTimer);
  }, [searchValueViewUser]);

  function handleEditVendor(data){
setUserData(data)
handleAddUserModal(2)
  }

  const handleAssignOrUpdateUser =()=>{
    if(selectedRows.length==0){
toast.warn("Please select a user first")
    }else{
      setApiLoading(true)
    
      console.log(selectedRows,"selectedRows")
      var data ={
        UserIds: selectedRows.map((item)=>item.UserId),
        PropertyId: localStorage.getItem("propId"),
      }
      dispatch(assignPropertyUserApi(data,(response)=>{
        if(response.data.statusCode===200){
          toast.success("User added successfully")
          }
        handleModalView()
                    getUserData()
        setApiLoading(false)
        
      },(res)=>{
        setApiLoading(false)
        
      }))
    }
  }


  return (
    <>


<ToastContainer />

<Modal className="fade" size='lg' show={modalView} centered>
     
        <Modal.Body>
        <div className="row d-flex justify-content-between">
        <div className="row">
        <div className="col-xxl-12">
       
          

            
              <div className="card-header border-0 pb-2 flex-wrap">
                <h4 className="heading me-2">User List</h4>

             
               
              </div>
            

              <UserTable
                      column={columns}
                      rowsArr={userListArr}
                 
            showLoading={apiLoading}
                
                   handleChangeRowsPerPagePagination={
                    handleChangeRowsPerPageViewUser
                  }
                  searchValuePagination={searchValueViewUser}
                  pageSizePagination={pageSizeViewUser}
                  handleSearchPagination={handleSearchViewUser}
                  totalCountPagination={totalPageViewUser}
                  handleOnChangePagination={onChangePageViewUser}
                  totalCount={totalViewUserCount}
                  handleEditVendor={handleEditVendor}
                  selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
          
                    />
               
         
         
         
        </div>
      </div>
      </div>
        </Modal.Body>
        <Modal.Footer>
          <Button

            variant="danger light"
           onClick={handleModalView}
          >
            Close
          </Button>
          <button

            className="btn btn-primary"
          onClick={handleAssignOrUpdateUser}
          >
          Assgin
          </button>
        </Modal.Footer>
      </Modal>


 
    

   {/* {userModalView && <AddVendorModal userModalView={userModalView} handleVendorModalView={handleAddUserModal} modalType={modalType} userData={userData}/>} */}
    
    
    </>
  );
};
export default AssignUserModal;
